module.exports = __webpack_public_path__ + "static/media/hosting.6ea2d552.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/services/hosting.svg
// module id = 379
// module chunks = 0